import React from 'react';
import { Redirect } from 'react-router-dom';
import { Row, Col, Checkbox } from 'react-bootstrap';
import TaxRules from '../../components/flightSelection/taxRules/TaxRules';
import FlightSelectionContainer from '../../components/flightSelectionContainer/FlightSelectionContainer';
import OverviewSearchBar from '../../components/overviewSearchBar/OverviewSearchBar';
import LoginContainer from '../../components/loginContainer/LoginContainer';
import Moment, { relativeTimeThreshold } from 'moment';
import Listener from '../../const/Listener';
import EventEmitter from '../../components/modules/event-emitter/EventEmitter';
import Airports from '../../services/airport/AirportService';
import FlighSearchValidation from '../../services/validation/FlightSearchValidation';
import { isFromCallcenter } from '../../services/queryService/QueryService';
import RefreshTokenCallcenterProvider from '../../components/providers/refreshTokenCallcenter/RefreshTokenCallcenterProvider';
import PropTypes from 'prop-types';
import FeatureService from '../../services/feature/FeatureService';
import Features from '../../const/Features';
import './FlightChangeSearchPage.css';
import Analytics from '../../components/modules/tudo-azul-analytics';
import DynamicPanel from '../../components/bookingResume/dynamicPanel/DynamicPanel';
import RefundRulesDetail from '../../components/flightSelection/refundRulesDetail/RefundRulesDetail';
import AirCompanyService from '../../services/airCompany/AirCompanyService';
import AttModal from '../../components/common/attPageModal/AttModal';
import data from '../../mocks/getPnrByIdResponse-roundtrip.json';
import AlertModalContainer from '../../components/alertModal/AlertModalContainer';
import Button from '../../components/button/Button';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';

const I18n = require('i18n-react').default;

const propTypes = {
  location: PropTypes.object,
  match: PropTypes.shape({
    params: PropTypes.object.isRequired
  }),
  history: PropTypes.any
};

class FlightChangeSearchPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flightsResponse: null,
      flightsFilter: this.props.location.state.filter,
      finalizeQuotation: false,
      showModal: false,
      isRedirect: false,
      urlRedirect: '/',
      renderFlightSelection: true,
      analyticsDataSelect: {},
      renderTaxLink: false,
      isCallcenterEnabled: false,
      isRefundRulesDetailEnabled: false,
      keepLoggedUser: false,
      airCompanyList: [],
      refundRule: null,
      isModalOpen: false,
      isLoginInCookie: false,
      termIsChecked: false,
      checkboxBorderName: '',
      modalInterval: null,
      mustShowModalAtt: false,
      openModalError: false
    };

    this.calculatePoints = false;

    this.sendAnalytics = this.sendAnalytics.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.redirectToHome = this.redirectToHome.bind(this);
    this.handleProceedToPayment = this.handleProceedToPayment.bind(this);
  }

  componentWillMount() {
    if (this.validParameters(this.props.match.params)) {
      const requestData = this.getFlightRequestData();
      const flightValidation = FlighSearchValidation.validateSearchRules(requestData.flightsFilter);
      if (flightValidation.hasValidSearch) {
        requestData.flightsFilter.minSelectionDate = flightValidation.minSelectionDate;
        requestData.flightsFilter.maxSelectionDate = flightValidation.maxSelectionDate;
        this.fillAirports(
          requestData.flightsFilter,
          requestData.flightsResponse,
          requestData.quotationJourney
        );

        FeatureService.isFeatureEnabled(Features.CALLCENTER_MODE).then(isEnabled => {
          this.setState({
            isCallcenterEnabled: isEnabled
          });
        });
        this.fillRefundRulesFeatureToggle();
        var promisse = this.getCompaniesList();
        promisse.then(() => {
          let companyParameters = [];
          if (this.props.match.params.companiesIdentity === '-') {
            companyParameters = this.state.airCompanyList;
          } else {
            companyParameters = this.props.match.params.companiesIdentity.split('-');
          }
          let airCompanyList = this.state.airCompanyList;
          companyParameters.map(e => {
            if (!airCompanyList.includes(e)) {
              this.redirectToHome();
            }
          });
        });
      } else {
        this.redirectToHome();
      }
    } else {
      this.redirectToHome();
    }
  }

  componentDidMount() {
    if (this.state.isRedirect === false) {
      window.scrollTo(0, 0);

      setTimeout(() => {
        this.setState({ mustShowModalAtt: true });
      }, 600000);

      this.setState({
        updateQuotationJourneylistener: EventEmitter.createListener(
          Listener.UPDATE_QUOTATION_JOURNEY,
          this.updateQuotationJourney
        )
      });

      this.setState({
        analyticsListener: EventEmitter.createListener(
          Listener.SEND_ANALYTICS_TAG,
          this.sendAnalytics
        )
      });
    }
    this.setState({
      loadedAvailabilitylistener: EventEmitter.createListener(
        Listener.LOADED_AVAILABILITY,
        this.loadedAvailability
      )
    });
  }

  componentWillUnmount() {
    EventEmitter.removeListener(this.state.updateQuotationJourneylistener);
    EventEmitter.removeListener(this.state.analyticsListener);
    EventEmitter.removeListener(this.state.loadedAvailabilitylistener);
  }

  fillRefundRulesFeatureToggle() {
    FeatureService.isFeatureEnabled(Features.REFUND_RULES_DETAIL).then(isEnabled => {
      this.setState({
        isRefundRulesDetailEnabled: isEnabled
      });
    });
  }

  loadedAvailability = eventData => {
    const loaded = (eventData && eventData[0]) || false;
    this.setState({
      renderTaxLink: loaded
    });
  };

  redirectToHome(callcenterMode) {
    this.setState({
      isRedirect: true,
      pathname: '/',
      keepLoggedUser: callcenterMode
    });
  }

  sendAnalytics(eventData) {
    try {
      const filter = eventData[0] || {};
      const flightsResponse = eventData[1] || {};
      const data = {
        departureDate: filter.startDate ? Moment(filter.startDate).format('YYYY-MM-DD') : null,
        returnDate: filter.endDate ? Moment(filter.endDate).format('YYYY-MM-DD') : null,
        tripType: filter.typeTrip,
        origin: filter.flightOrigin.code,
        destination: filter.flightDestiny.code,
        adults: filter.totalAdults,
        children: filter.totalKids,
        babies: filter.totalBabys,
        resultsQuantity: this.getResultsQuantity(flightsResponse)
      };
      this.setState({
        analyticsDataSelect: data
      });
      Analytics.trackingSelect(data);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Analytics not sent, error in execution');
    }
  }

  getResultsQuantity(response) {
    let resultsQuantity = 0;
    if (response.departureFlights && response.departureFlights.flights) {
      resultsQuantity += response.departureFlights.flights.length;
    }
    if (response.returnFlights && response.returnFlights.flights) {
      resultsQuantity += response.returnFlights.flights.length;
    }
    return resultsQuantity;
  }

  getFlightRequestData() {
    return {
      quotationJourney: {
        passengers: {
          adultNumber: Number(this.props.match.params.ADT),
          childNumber: Number(this.props.match.params.CHD),
          infantNumber: Number(this.props.match.params.INF)
        },
        origin: this.props.match.params.originJ1.toUpperCase(),
        finalDestination: this.props.match.params.destinationJ1.toUpperCase()
      },
      flightsFilter: {
        typeTrip: this.props.match.params.tripType.toUpperCase() === 'RT' ? 'roundTrip' : 'oneWay',
        flightOrigin: {
          code: this.props.match.params.originJ1.toUpperCase()
        },
        flightDestiny: {
          code: this.props.match.params.destinationJ1.toUpperCase()
        },
        startDate: Moment(this.props.match.params.departureDateTime, 'YYYY-MM-DD').toISOString(),
        endDate:
          this.props.match.params.returnDateTime !== '-'
            ? Moment(this.props.match.params.returnDateTime, 'YYYY-MM-DD').toISOString()
            : null,
        totalAdults: parseInt(this.props.match.params.ADT, 10),
        totalKids: parseInt(this.props.match.params.CHD, 10),
        totalBabys: parseInt(this.props.match.params.INF, 10),
        cabinCategory: this.props.match.params.cabinCategory.toUpperCase(),
        typeOfFlight: this.props.match.params.typeOfFlight.toUpperCase(),
        companiesIdentity: this.props.match.params.companiesIdentity.toUpperCase()
      },
      flightsResponse: {
        isFromDeeplink: true,
        origin: this.props.match.params.originJ1.toUpperCase(),
        originAirportName: '',
        finalDestination: this.props.match.params.destinationJ1.toUpperCase(),
        finalDestinationAirportName: '',
        passengers: {
          adultNumber: parseInt(this.props.match.params.ADT, 10),
          childNumber: parseInt(this.props.match.params.CHD, 10),
          infantNumber: parseInt(this.props.match.params.INF, 10)
        },
        departureFlights: {
          date: Moment(this.props.match.params.departureDateTime, 'YYYY-MM-DD').toISOString(),
          flights: []
        },
        returnFlights: {
          date:
            this.props.match.params.returnDateTime !== '-'
              ? Moment(this.props.match.params.returnDateTime, 'YYYY-MM-DD').toISOString()
              : null,
          flights: []
        },
        companiesIdentity: this.props.match.params.companiesIdentity,
        typeOfFlight: this.props.match.params.typeOfFlight
      }
    };
  }

  fillAirports(flightsFilter, flightsResponse, quotationJourney) {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.filter &&
      this.props.location.state.filter.flightOrigin.name &&
      this.props.location.state.filter.flightDestiny.name
    ) {
      const origin = this.props.location.state.filter.flightOrigin;
      const destination = this.props.location.state.filter.flightDestiny;

      origin.name = origin.name.replace(` (${origin.code})`, '');
      destination.name = destination.name.replace(` (${destination.code})`, '');

      flightsFilter.flightOrigin = origin;
      flightsFilter.flightDestiny = destination;

      flightsResponse.originAirportName = origin.name;
      flightsResponse.finalDestinationAirportName = destination.name;

      this.setState({
        quotationJourney: quotationJourney,
        flightsFilter: flightsFilter,
        flightsResponse: flightsResponse,
        renderFlightSelection: true
      });
    } else {
      this.getAirports(flightsFilter, flightsResponse, quotationJourney);
    }
  }

  getAirports(flightsFilter, flightsResponse, quotationJourney) {
    Airports.getAirportList(this.props.match.params.originJ1).then(res => {
      let flightOrigin = res.data.find(item => {
        return item.code.toUpperCase() === this.props.match.params.originJ1.toUpperCase();
      });
      flightsFilter.flightOrigin = flightOrigin;
      flightsResponse.originAirportName = flightOrigin.name;
      let ignoreCode = flightOrigin.searchCode === '1N' ? '1N' : '';
      let ignoreAirport = flightOrigin.code;
      Airports.getAirportList(
        this.props.match.params.destinationJ1,
        ignoreCode,
        ignoreAirport
      ).then(res => {
        let flightDestiny = res.data.find(item => {
          return item.code.toUpperCase() === this.props.match.params.destinationJ1.toUpperCase();
        });
        flightsFilter.flightDestiny = flightDestiny;
        flightsResponse.finalDestinationAirportName = flightDestiny.name;
        this.setState({
          quotationJourney: quotationJourney,
          flightsFilter: flightsFilter,
          flightsResponse: flightsResponse,
          renderFlightSelection: true
        });
      });
    });
  }

  getCompaniesList() {
    return AirCompanyService.getAirCompanytList().then(response => {
      let airCompanyList = [];
      response.data.forEach(element => {
        airCompanyList.push(element.code);
      });
      this.setState({
        airCompanyList: airCompanyList
      });
    });
  }

  validParameters(parameters) {
    let validation = this.validationParametersArray(parameters);
    let find = validation.find(item => {
      return item === false;
    });

    return find === undefined;
  }

  validationParametersArray(parameters) {
    return [
      ['RT', 'OW'].includes(parameters.tripType.toUpperCase()),
      new RegExp('^[A-Za-z]+$').test(parameters.originJ1.toUpperCase()),
      new RegExp('(^[A-Za-z]+$|^-$)').test(parameters.destinationJ1.toUpperCase()),
      Moment(parameters.departureDateTime, 'YYYY-MM-DD').isValid(),
      Moment(parameters.returnDateTime, 'YYYY-MM-DD').isValid() ||
      parameters.returnDateTime === '-',
      Number.isInteger(parseInt(parameters.ADT, 10)),
      Number.isInteger(parseInt(parameters.CHD, 10)),
      Number.isInteger(parseInt(parameters.INF, 10)),
      ['A', 'D'].includes(parameters.typeOfFlight.toUpperCase())
    ];
  }

  updateQuotationJourney = ([quotationJourney]) => {
    this.setState({
      quotationJourney: quotationJourney
    });
  };

  selectFlights = (departureFlight, returnFlight) => {
    this.calculatePoints = false;
    this.setState({
      finalizeQuotation: true,
      quotationJourney: {
        ...this.state.quotationJourney,
        departureFlight: departureFlight,
        returnFlight: returnFlight
      }
    });
  };

  alterFlights = () => {
    this.setState({
      finalizeQuotation: false,
      termIsChecked: false,
      checkboxBorderName: ''
    });
  };

  deleteFlights = (departureFlight, returnFlight) => {
    sessionStorage.setItem('departure', departureFlight.flight.id);
    if (returnFlight) sessionStorage.setItem('return', returnFlight.flight.id);
    window.location.reload();
  };

  alterSearch = () => {
    this.redirectToHome(this.callCenterMode());
  };

  callCenterMode() {
    return this.state.isCallcenterEnabled && isFromCallcenter();
  }

  updatePage = () => {
    this.forceUpdate();
  };

  openTagRulesModal = () => {
    this.setState({
      showModal: true
    });
  };

  closeTagRulesModal = () => {
    this.setState({
      showModal: false
    });
  };

  setRefundRule = refundRule => {
    this.setState({
      quotationJourney: {
        ...this.state.quotationJourney,
        refundRule: refundRule
      }
    });
  };

  toggleModal() {
    this.setState({
      isModalOpen: !this.state.isModalOpen
    });
  }

  renderFinalizeQuotation() {
    if (this.state.finalizeQuotation) {
      var nextPageButton = null;
      if (!this.calculatePoints) {
        this.calculatePoints = true;
      }

      nextPageButton = (
        <Button
          name="proceedButton"
          background="navy-blue"
          className="text-xl"
          onClick={() => this.handleProceedToPayment()}
          disabled={this.state.termIsChecked ? false : true}>
          {I18n.translate('components.flightChange.proceedButton')}
        </Button>
      );
      return nextPageButton;
    }
  }

  renderRefundRules() {
    if (this.state.isRefundRulesDetailEnabled && this.state.finalizeQuotation) {
      return (
        <DynamicPanel
          id="componentDynamicPanelRefundRules"
          title={I18n.translate('components.refundRulesDetail.title')}
          openCollapse={true}>
          <RefundRulesDetail
            departureFlight={this.state.quotationJourney.departureFlight}
            returnFlight={this.state.quotationJourney.returnFlight}
            passengers={this.state.quotationJourney.passengers}
            callbackSetRefundRule={this.setRefundRule}
            callbackDeleteFlights={this.deleteFlights}
            callbackHome={this.redirectToHome}
          />
        </DynamicPanel>
      );
    }
  }

  renderRowFinalizeQuotation() {
    return (
      <div>
        <Row className="rules-finalize-login-row">
          <Col xs={12} className="no-padding text-left refund-rules-col">
            {this.renderRefundRules()}
          </Col>
          <Col>{this.renderCheckBox()}</Col>
          <Col xs={12} className="no-padding text-right">
            {this.renderFinalizeQuotation()}
          </Col>
        </Row>
      </div>
    );
  }

  renderTerm1() {
    if (this.callCenterMode()) {
      return I18n.translate('components.refundRulesDetail.term1CallCenter');
    }
    return I18n.translate('components.refundRulesDetail.term1');
  }

  setAgreeCancellationTerms = () => {
    let termIsChange = !this.state.termIsChecked;
    this.setState({
      quotationJourney: {
        ...this.state.quotationJourney,
        agreeCancellationTerms: termIsChange
      },
      termIsChecked: termIsChange
    });
  };

  setCheckboxBorderNameCallback = checkboxBorderName => {
    this.setState({
      checkboxBorderName: checkboxBorderName
    });
  };

  renderCheckBox() {
    if (this.state.isRefundRulesDetailEnabled && this.state.finalizeQuotation) {
      return (
        <Row>
          <Col xs={8} sm={12} className="flightChangeSearchPage__colCheckbox">
            <div
              className={`flightChangeSearchPage__checkbox ${this.state.termIsChecked ? 'checked' : this.state.checkboxBorderName
                }`}>
              <Checkbox
                id="ckBxTerm"
                bsClass={`checkbox flightChangeSearchPage__checkbox--input ${this.state.termIsChecked ? 'checked' : ''
                  }`}
                onChange={() => {
                  this.setAgreeCancellationTerms();
                }}
                checked={this.state.termIsChecked}
              />
              <label className="flightChangeSearchPage__checkbox--text">
                {this.renderTerm1()}
                <a onClick={this.toggleModal}>{I18n.translate('checkout.airTransportContract')}</a>
                {I18n.translate('components.refundRulesDetail.term2')}
              </label>
            </div>
          </Col>
          <TaxRules id="flightsTax" close={this.toggleModal} showModal={this.state.isModalOpen} />
        </Row>
      );
    }
  }

  renderModalAtt() {
    return (
      <AttModal
        id="modalRefundRulesDetailsAtt"
        firstOption={() => {
          window.location.reload();
        }}
        secondOption={() => {
          window.history.back();
        }}
        ref={c => {
          this.modalRefundRulesDetailsError = c;
        }}
      />
    );
  }

  handleProceedToPayment = () => {
    this.setState({
      isRedirect: true,
      pathname: '/paymentChange'
    });
  };

  showModalError(message) {
    this.setState({
      openModalError: true,
      messageInfo: message
    });
  }

  closeModalError = () => {
    this.setState({
      openModalError: false
    });
  };

  render() {
    const isThereData =
      this.state.quotationJourney &&
      this.state.flightsFilter &&
      this.state.analyticsDataSelect &&
      this.state.keepLoggedUser;
    return (
      <div>
        <OverviewSearchBar
          origin={this.state.flightsFilter.flightOrigin.code}
          destination={this.state.flightsFilter.flightDestiny.code}
          departureDate={this.state.flightsFilter.startDate}
          returnDate={this.state.flightsFilter.endDate}
          totalAdults={this.state.flightsFilter.totalAdults}
          totalKids={this.state.flightsFilter.totalKids}
          totalBabys={this.state.flightsFilter.totalBabys}
          alterSearchCallback={this.alterSearch}
          alterFlightOverviewPrice={false}
          steps={
            ['components.steps.search', 'components.steps.flightSelection'] // true
          }
          history={this.props.history}
          stepsBreadcrumb={[
            'features.breadcrumb.reservation',
            'features.breadcrumb.pnrDetail',
            'features.breadcrumb.change',
            'features.breadcrumb.selection'
          ]}
          actualStepBreadcrumb="features.breadcrumb.selection"
          ref={c => {
            this.overviewSearchBar = c;
          }}
          renderOpen={true}
        />
        <div id="pageFlightChangeSearch">
          <section className="container-fluid section__outer">
            {this.state.renderFlightSelection ? (
              <div>
                <FlightSelectionContainer
                  id="flightSelectionContainer"
                  {...this.state.flightsResponse}
                  filter={this.state.flightsFilter}
                  callbackSelectFlights={this.selectFlights}
                  callbackAlterFlights={this.alterFlights}
                  callbackDepartureDelete={sessionStorage.getItem('departure')}
                  callbackReturnDelete={sessionStorage.getItem('return')}
                  updatePage={this.updatePage}
                  location={this.props.location}
                  handleProceedToPayment={this.handleProceedToPayment}
                  ref={c => {
                    this.flightSelectionContainer = c;
                  }}
                />
                {this.renderRowFinalizeQuotation()}
              </div>
            ) : null}
            {this.state.isRedirect ? (
              <Redirect
                push
                to={{
                  pathname: this.state.pathname,
                  state: {
                    quotationJourney: this.state.quotationJourney,
                    flightsFilter: this.state.flightsFilter,
                    analyticsDataSelect: this.state.analyticsDataSelect,
                    keepLoggedUser: this.state.keepLoggedUser,
                    pnrNumber: this.props.location.state.pnrNumber,
                    azulNumber: this.props.location.state.azulNumber,
                  },
                  ...(this.props.location && {
                    search: this.props.location ? this.props.location.search : null
                  })
                }}
              />
            ) : null}
          </section>
          {this.state.mustShowModalAtt && this.renderModalAtt()}
          <AlertModalContainer
            title={I18n.translate('label.insufficientPoints').toString()}
            message={I18n.translate('message.insufficientPoints').toString()}
            visible={false}
            closeModal={() => { }}
          />
          <InfoModal
            id="modalError"
            message={this.state.messageInfo}
            showModal={this.state.openModalError}
            close={this.closeModalError}
            ref={c => {
              this.modalError = c;
            }}
          />
        </div>
      </div>
    );
  }
}

FlightChangeSearchPage.propTypes = propTypes;

export default FlightChangeSearchPage;



// WEBPACK FOOTER //
// ./src/page/flightChangeSearch/FlightChangeSearchPage.jsx